import { Controller } from "@hotwired/stimulus"

// Generates a clean uppercase coupon code (no spaces, A-Z + 0-9) and
// drops it into the code input. Used by the "↻ Générer" button on the
// promo wizard step 2.
export default class extends Controller {
  static targets = ["input"]

  generate(event) {
    event.preventDefault()
    if (!this.hasInputTarget) return
    this.inputTarget.value = this.#randomCode()
  }

  #randomCode() {
    // 10-char A-Z + 0-9 — short enough to type, long enough to avoid clashes.
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
    let code = ""
    const random = new Uint8Array(10)
    crypto.getRandomValues(random)
    for (let i = 0; i < random.length; i++) {
      code += chars[random[i] % chars.length]
    }
    return code
  }
}
